import { Text } from "@chakra-ui/layout";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";

type Props = {
  amount: number;
};

export const ProfitAndRevenueAmount = observer(function ColoredText({
  amount,
}: Props) {
  return (
    <Text pr="5" color={amount < 0 ? "red.400" : undefined}>
      {currency.formatByWorkspace(amount)}
    </Text>
  );
});
